import {
  Channel3r72atmcithql as Channel,
  ClosedSendChannelException29m33prpq9jaw as ClosedSendChannelException,
  ClosedReceiveChannelException3ofg6gf5f5b38 as ClosedReceiveChannelException,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Channel.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Job13y4jkazwjho0 as Job,
  Key_instancebefxze3q9f64 as Key_instance,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { get_LOGGER1pnacb4n2g1eb as get_LOGGER } from './DefaultWebSocketSession.mjs';
import {
  Pong3m3cas9hmc9ec as Pong,
  Ping3nta6l7sdq1r9 as Ping,
} from './Frame.web.mjs';
import { cancelConsumed2i0oizqhmljf6 as cancelConsumed } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Channels.common.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Charsets_getInstance3jooo7e4x0j2x as Charsets_getInstance } from '../../../../ktor-ktor-io/io/ktor/utils/io/charsets/Charset.js.mjs';
import { toByteArray1i3ns5jnoqlv6 as toByteArray } from '../../../../ktor-ktor-io/io/ktor/utils/io/core/Strings.mjs';
import { decodeToString1dbzcjd620q25 as decodeToString } from '../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { getTimeMillis12o7k17x9fmwi as getTimeMillis } from '../../../../ktor-ktor-utils/io/ktor/util/date/DateJs.mjs';
import { Randomei1bbeye8rr8 as Random } from '../../../../kotlin-kotlin-stdlib/kotlin/random/Random.mjs';
import { withTimeoutOrNull3qi35nuwr2k8a as withTimeoutOrNull } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Timeout.mjs';
import { toHexString5bhtjxqec7ow as toHexString } from '../../../../kotlin-kotlin-stdlib/kotlin/text/HexExtensions.mjs';
import {
  CloseReason10cphaqpp3ct7 as CloseReason,
  Codes_INTERNAL_ERROR_getInstance3v6rjxm79q45d as Codes_INTERNAL_ERROR_getInstance,
} from './CloseReason.mjs';
import { ClosedByteChannelException3il8gfpye60w as ClosedByteChannelException } from '../../../../ktor-ktor-io/io/ktor/utils/io/Exceptions.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { CoroutineName2g5zosw74tf0f as CoroutineName } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineName.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_PongerCoroutineName() {
  _init_properties_PingPong_kt__9aqxey();
  return PongerCoroutineName;
}
var PongerCoroutineName;
function get_PingerCoroutineName() {
  _init_properties_PingPong_kt__9aqxey();
  return PingerCoroutineName;
}
var PingerCoroutineName;
function ponger(_this__u8e3s4, outgoing) {
  _init_properties_PingPong_kt__9aqxey();
  var channel = Channel(5);
  var tmp = get_PongerCoroutineName();
  launch(_this__u8e3s4, tmp, VOID, ponger$slambda(channel, outgoing));
  return channel;
}
function pinger(_this__u8e3s4, outgoing, periodMillis, timeoutMillis, onTimeout) {
  _init_properties_PingPong_kt__9aqxey();
  var actorJob = Job();
  var channel = Channel(2147483647);
  var tmp = actorJob.pm(get_PingerCoroutineName());
  launch(_this__u8e3s4, tmp, VOID, pinger$slambda(periodMillis, timeoutMillis, onTimeout, channel, outgoing));
  var tmp_0 = ensureNotNull(_this__u8e3s4.bw().bd(Key_instance));
  tmp_0.ex((it) => {
    actorJob.mx();
    return Unit_instance;
  });
  return channel;
}
function ponger$slambda($channel, $outgoing) {
  return constructCallableReference(function *($this$launch, $completion) {
    var tmp;
    try {
      // Inline function 'kotlinx.coroutines.channels.consumeEach' call
      var tmp0 = $channel;
      $l$block: {
        // Inline function 'kotlinx.coroutines.channels.consume' call
        var cause = null;
        try {
          var _iterator__ex2g4s = tmp0.p1();
          while (yield* _iterator__ex2g4s.n1a($completion)) {
            var e = _iterator__ex2g4s.r1();
            get_LOGGER().b4u('Received ping message, sending pong message');
            yield* $outgoing.b1b(Pong().g5d(e.h5b_1), $completion);
          }
          break $l$block;
        } catch ($p) {
          if ($p instanceof Error) {
            var e_0 = $p;
            cause = e_0;
            throw e_0;
          } else {
            throw $p;
          }
        }
        finally {
          cancelConsumed(tmp0, cause);
        }
      }
      tmp = Unit_instance;
    } catch ($p_0) {
      var tmp_0;
      if ($p_0 instanceof ClosedSendChannelException()) {
        var _unused_var__etf5q3 = $p_0;
        tmp_0 = Unit_instance;
      } else {
        throw $p_0;
      }
      tmp = tmp_0;
    }
    return Unit_instance;
  }, 1);
}
function pinger$slambda$slambda($channel) {
  return constructCallableReference(function *($this$withTimeoutOrNull, $completion) {
    while (true) {
      yield* $channel.e1b($completion);
    }
    return Unit_instance;
  }, 1);
}
function pinger$slambda$slambda_0($outgoing, $pingMessage, $channel) {
  return constructCallableReference(function *($this$withTimeoutOrNull, $completion) {
    get_LOGGER().b4u('WebSocket Pinger: sending ping frame');
    yield* $outgoing.b1b(Ping().s5d(toByteArray($pingMessage, Charsets_getInstance().g4m_1)), $completion);
    $l$loop: while (true) {
      var msg = yield* $channel.e1b($completion);
      if (decodeToString(msg.h5b_1, 0, 0 + msg.h5b_1.length | 0) === $pingMessage) {
        get_LOGGER().b4u('WebSocket Pinger: received valid pong frame ' + msg.toString());
        break $l$loop;
      }
      get_LOGGER().b4u('WebSocket Pinger: received invalid pong frame ' + msg.toString() + ', continue waiting');
    }
    return Unit_instance;
  }, 1);
}
function pinger$slambda($periodMillis, $timeoutMillis, $onTimeout, $channel, $outgoing) {
  return constructCallableReference(function *($this$launch, $completion) {
    get_LOGGER().b4u('Starting WebSocket pinger coroutine with period ' + $periodMillis.toString() + ' ms and timeout ' + $timeoutMillis.toString() + ' ms');
    var random = Random(getTimeMillis());
    var pingIdBytes = new Int8Array(32);
    var tmp;
    try {
      $l$loop: while (true) {
        yield* withTimeoutOrNull($periodMillis, pinger$slambda$slambda($channel), $completion);
        random.jo(pingIdBytes);
        var pingMessage = '[ping ' + toHexString(pingIdBytes) + ' ping]';
        var rc = yield* withTimeoutOrNull($timeoutMillis, pinger$slambda$slambda_0($outgoing, pingMessage, $channel), $completion);
        if (rc == null) {
          get_LOGGER().b4u('WebSocket pinger has timed out');
          yield* $onTimeout(CloseReason().z5a(Codes_INTERNAL_ERROR_getInstance(), 'Ping timeout'), $completion);
          break $l$loop;
        }
      }
      tmp = Unit_instance;
    } catch ($p) {
      var tmp_0;
      if ($p instanceof CancellationException()) {
        var ignore = $p;
        tmp_0 = Unit_instance;
      } else {
        if ($p instanceof ClosedReceiveChannelException()) {
          var ignore_0 = $p;
          tmp_0 = Unit_instance;
        } else {
          if ($p instanceof ClosedSendChannelException()) {
            var ignore_1 = $p;
            tmp_0 = Unit_instance;
          } else {
            if ($p instanceof ClosedByteChannelException()) {
              var ignore_2 = $p;
              tmp_0 = Unit_instance;
            } else {
              throw $p;
            }
          }
        }
      }
      tmp = tmp_0;
    }
    return Unit_instance;
  }, 1);
}
var properties_initialized_PingPong_kt_fbfhmc;
function _init_properties_PingPong_kt__9aqxey() {
  if (!properties_initialized_PingPong_kt_fbfhmc) {
    properties_initialized_PingPong_kt_fbfhmc = true;
    PongerCoroutineName = new (CoroutineName())('ws-ponger');
    PingerCoroutineName = new (CoroutineName())('ws-pinger');
  }
}
//region block: exports
export {
  pinger as pingerd16zvjbf6m9o,
  ponger as ponger270tezdl2mu68,
};
//endregion

//# sourceMappingURL=PingPong.mjs.map
